import { useMemo } from 'react';
import { defaultContainer } from './ioc-container';
import { ServiceIdentifier } from 'inversify';

export function useService<T>(type: ServiceIdentifier<T>): T {
	return useMemo(() => defaultContainer.get<T>(type), [type]);
}
